/**@author Lupita Llamas
 * Model for the contact's answers
 */
export class Answer {

  constructor(
    public unique_id: string,
    public email: string,
    public answers: any
  ) {}
}



// WEBPACK FOOTER //
// ./src/app/models/answer.ts